/**
 * Production-safe debug utilities
 * Prevents sensitive data from leaking in production console logs
 */

const isDevelopment = process.env.NODE_ENV === 'development';

/**
 * Development-only console.log
 * @param {...any} args - Arguments to log
 */
export const debugLog = (...args) => {
  if (isDevelopment) {
    console.log(...args);
  }
};

/**
 * Development-only console.error with generic fallback
 * @param {...any} args - Arguments to log
 */
export const debugError = (...args) => {
  if (isDevelopment) {
    console.error(...args);
  } else {
    // Log only generic error message in production
    console.error('An error occurred');
  }
};

/**
 * Development-only console.warn
 * @param {...any} args - Arguments to log
 */
export const debugWarn = (...args) => {
  if (isDevelopment) {
    console.warn(...args);
  }
};

/**
 * Development-only console.info
 * @param {...any} args - Arguments to log
 */
export const debugInfo = (...args) => {
  if (isDevelopment) {
    console.info(...args);
  }
};

/**
 * Production-safe error logging with sanitized message
 * Logs detailed error in development, generic message in production
 * @param {string} context - Context of the error (e.g., "fetching balance")
 * @param {Error} error - The error object
 */
export const logError = (context, error) => {
  if (isDevelopment) {
    console.error(`Error ${context}:`, error);
  } else {
    console.error(`Error ${context}`);
  }
};

/**
 * Conditionally log sensitive data only in development
 * @param {string} label - Label for the data
 * @param {any} data - The sensitive data to log
 */
export const debugSensitive = (label, data) => {
  if (isDevelopment) {
    console.log(`[SENSITIVE] ${label}:`, data);
  }
};

export default {
  debugLog,
  debugError,
  debugWarn,
  debugInfo,
  logError,
  debugSensitive,
  isDevelopment
};
